import React from 'react';

type Props = {
  orderId: string;
  onBack(): void;
};

export default function NeedOrderCancelPage(props: Props) {
  return (
    <>
      <header>
        <h4>You’ll need to cancel the order first</h4>
      </header>
      <main>
        <div className='request-refund-modal__page-content'>
          <p>
            Refunds related to order cancellations are handled during the
            cancellation process. Once you cancel the order, you’ll be able to
            fill the refund amount and confirm the request.
          </p>
          <b>Steps</b>
          <ol>
            <li>Cancel fulfilled order.</li>
            <li>Confirm cancellation reason.</li>
            <li>Fill the refund amount and request a refund.</li>
          </ol>
        </div>
      </main>
      <footer className='modal__footer'>
        <menu className='modal__actions modal__actions--between'>
          <button
            key='back'
            className='btn btn-secondary btn--wide'
            type='button'
            onClick={props.onBack}
          >
            Back
          </button>
          <button
            key='cancelOrder'
            className='btn btn-primary btn--wide'
            type='button'
            onClick={() => {
              window.location.assign(`/orders/${props.orderId}/cancel/`);
            }}
          >
            Cancel Order
          </button>
        </menu>
      </footer>
    </>
  );
}
